import { BonusCampaign } from '../../../api/fetchers/bonusPromotions/types/bonus';
import { ChipTypes } from '../chips/types';

export const IFRAME_TYPE = {
  LOBBY: 'LOBBY',
  TABLE: 'TABLE',
  MTB: 'MTB',
} as const;

export type IFrameType = (typeof IFRAME_TYPE)[keyof typeof IFRAME_TYPE];

export interface TableInfo {
  tableId: string;
  iframeType: IFrameType;
  operatorGameId?: string;
  isMtbMinimized?: boolean;
}

export interface BetInfoDetails {
  betAmount: number;
  isBetClosed: boolean;
  betType: ChipTypes;
  bonusId: number;
  actualBetAmount: number;
  winAmount: number;
}

export interface BetInfo {
  [tableId: string]: BetInfoDetails;
}

export interface LauncherSliceType {
  isLauncher: boolean;
  isActiveTable: boolean;
  tables: TableInfo[];
  betInfo: BetInfo;
  masterVolume: number;
  activeBonusCampaign: BonusCampaign;
  isInGameMTP: boolean;
  gameLanguage: string | null;
}
